import { useForm, useFieldArray } from "react-hook-form";
import { Btn, H4, H2, P } from "../../../AbstractElements";
import React, { Fragment, useEffect } from "react";
import { useState, useCallback } from "react";
import { Col, Label, Row } from "reactstrap";
import Form from "react-bootstrap/Form";
import * as mutations from "../../../graphql/mutations";
import * as queries from "../../../graphql/queries";
import uuid from "react-native-uuid";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";
import CompanyDetails from "./CompanyDetails";
import AssetOwner from "./AssetOwner";
import { Autocomplete, useLoadScript } from "@react-google-maps/api";
import { result } from "lodash";
import { DEVELOPERTESTING, LINKS_API } from "../../../Config/Config";
import { generateClient } from "aws-amplify/api";
import siteDetailsImg from "../../../assets/images/siteDetails.png";
import axios from "axios";
const client = generateClient({
  headers: {
    "x-api-key": "da2-ox6gomta4baghjuzk6hpogw25y",
  },
});
const placesLibrary = ["places"];

const SiteDetails = (props) => {
  const [catId, setCatId] = useState();
  const [maxNum, setmaxNum] = useState();

  const { isLoaded } = useLoadScript({
    googleMapsApiKey: "AIzaSyBTumeD-l8p-2slpOP7PEJ7KKOlaFfOOj4",
    libraries: placesLibrary,
  });
  const [locations, setLocations] = useState([]);
  const [siteAdress, setsiteAdress] = useState();
  const [siteAdressArray, setsiteAdressArray] = useState([]);
  const {
    register,
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    shouldUnregister: true, // 👈 VERY IMPORTANT
    defaultValues: {
      siteDetails: [
        {
          siteName: "",
          siteAddress: "",
        },
      ],
    },
  });
  const { fields, append, remove } = useFieldArray({
    control,
    name: "siteDetails",
    keyName: "fieldId", // 👈 IMPORTANT FIX
  });

  useEffect(() => {
    SerialId();
    async function SerialId() {
      await client
        .graphql({
          query: queries.listDistributionBoxes,
          authMode: "API_KEY",
          variables: {
            limit: 10000,
          },
        })
        .then((response) => {
          const DistributionBoxesData =
            response.data.listDistributionBoxes.items;

          let idArry = [];
          let maxnumber = 0;

          DistributionBoxesData.map((item) => {
            if (
              item.distributionBoxNumber !== "" &&
              item.distributionBoxNumber !== null
            ) {
              if (
                isNaN(Number(item.distributionBoxNumber.replace(/^\D+/g, "")))
              ) {
                idArry.push(1);
              } else {
                idArry.push(
                  Number(item.distributionBoxNumber.replace(/^\D+/g, "")),
                );
              }
            }
          });

          maxnumber = Math.max(...idArry);
          if (idArry.length > 0) {
            if (maxnumber !== 0 && maxnumber !== null) {
              const res = digits_count(Number(maxnumber + 1));
              if (res === 1) {
                setCatId("000");
                setmaxNum(maxnumber + 1);
              } else if (res === 2) {
                setCatId("00");
                setmaxNum(maxnumber + 1);
              } else if (res === 3) {
                setCatId("0");
                setmaxNum(maxnumber + 1);
              } else if (res === 4) {
                setCatId("");
                setmaxNum(maxnumber + 1);
              }
            } else {
              setCatId("000");
              setmaxNum(1);
            }
          } else {
            setCatId("000");
            setmaxNum(1);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, []);
  //--------------------------------------------------------------------------------------

  const digits_count = (n) => {
    var count = 0;
    if (n >= 1) ++count;
    while (n / 10 >= 1) {
      n /= 10;
      ++count;
    }
    return count;
  };

  const onSubmit = async (data) => {
    try {
      const inputArray = data.siteDetails;

      console.log("Form Data:", inputArray);
      console.log("props", props);

      const permissionsList = [
        "Create Assets",
        "Import Assets",
        "Edit Assets",
        "View Assets",
        "Create Tasks",
        "Assign Tasks",
        "View Tasks",
        "Export Tasks",
        "Create Sites",
        "Edit Sites",
        "View Sites",
        "Import Sites",
        "Create Certificates",
        "View Certificates",
        "Download Reports",
        "View Reports",
        "View Logbooks",
        "View Service Providers",
      ];

      // CREATE COMPANY

      const companyResponse = await client.graphql({
        query: mutations.createCompanyDetails,
        variables: {
          input: {
            companyName: props.values.CompanyName,
            companyBN: props.values.BusinessNumber,
            companyAddress: props.values.CompanyAddress,
            email: props.values.Aomail,
            status: "Active",
          },
        },
        authMode: "API_KEY",
      });

      const companyId = companyResponse.data.createCompanyDetails.id;

      console.log("Company Created:", companyId);

      // CREATE ASSET OWNER

      const AOResult = await client.graphql({
        query: mutations.createAssetOwner,
        variables: {
          input: {
            id: props.values.UserId,
            firstName: props.values.FirstName,
            lastName: props.values.LastName,
            email: props.values.Aomail,
            mobile: props.values.MObileAssetOwner,
            companydetailsID: companyId,
            companyName: props.values.CompanyName,
            profilePicture: props.values.aoPic,
            status: "Active",
            permission: JSON.stringify(permissionsList),
          },
        },
        authMode: "API_KEY",
      });

      console.log("Asset Owner Created", AOResult);

      // CREATE SITES

      const siteDetailsId = [];

      for (const site of inputArray) {
        const siteResponse = await client.graphql({
          query: mutations.createSiteDetails,
          variables: {
            input: {
              unitNumber: site.siteAddress,
              siteName: site.siteName,
              assetownerID: props.values.UserId,
              companydetailsID: companyId,
              status: "Active",
            },
          },
          authMode: "API_KEY",
        });

        const siteId = siteResponse.data.createSiteDetails.id;

        siteDetailsId.push(siteId);

        console.log("Site Created:", siteId);

        // CREATE LOGBOOK

        await client.graphql({
          query: mutations.createLogBook,
          variables: {
            input: {
              siteId: siteId,
              sitedetailsID: siteId,
              status: "Active",
              logbookName: `${site.siteName} - Default Logbook`,
            },
          },
          authMode: "API_KEY",
        });

        // LINK USER AND SITE

        await client.graphql({
          query: mutations.createLinkUsersAndSite,
          variables: {
            input: {
              sitedetailsID: siteId,
              userdetailsID: props.values.UserId,
              status: "Active",
            },
          },
          authMode: "API_KEY",
        });
      }

      console.log("All Sites Created");

      // CREATE SP COMPANY
      const SPComp = await client.graphql({
        query: mutations.createSPCompanyDetails,
        variables: {
          input: {
            id: companyId,
            companyName: props.values.CompanyName,
            companyBN: props.values.BusinessNumber,
            companyAddress: props.values.CompanyAddress,
            companyLicense: props.values.splicence,
            status: "Active",
            email: props.values.Aomail,
          },
        },
        authMode: "API_KEY",
      });

      console.log("SP Company Created", SPComp);

      // CREATE SP USER

      const SPUser = await client.graphql({
        query: mutations.createSPUserDetails,
        variables: {
          input: {
            id: props.values.UserId,
            fname: props.values.FirstName,
            lname: props.values.LastName,
            email: props.values.Aomail,
            mobile: props.values.MObileAssetOwner,
            license: props.values.splicence,
            profilepic: props.values.aoPic,
            SPGroup: "admin",
            status: "Active",
            userGroup: "electrician",
            permission: JSON.stringify(permissionsList),
            spcompanydetailsID: companyId,
          },
        },
        authMode: "API_KEY",
      });

      console.log("SP User Created", SPUser);

      // CREATE USER DETAILS

      const Userdetails = await client.graphql({
        query: mutations.createUserDetails,
        variables: {
          input: {
            id: props.values.UserId,
            username: props.values.Username,
            email: props.values.Aomail,
            companyDetailsId: companyId,
            assetOwnerId: props.values.UserId,
            siteDetailsId: siteDetailsId,
            paymentId: props.values.PaymentId,
            status: "Active",
            permissions: JSON.stringify(permissionsList),
          },
        },
        authMode: "API_KEY",
      });

      console.log("User Details Created", Userdetails);

      toast.success("Registration Completed Successfully!", {
        position: toast.POSITION.TOP_CENTER,
      });

      // REDIRECT TO STRIPE
      const userSub = props.values.UserId;
      let typePayment = "";
      if (props.values.PaymentId === "1") {
        typePayment = "LITE";
      } else if (props.values.PaymentId === "2") {
        typePayment = "TIER1";
      } else if (props.values.PaymentId === "3") {
        typePayment = "TIER2";
      } else if (props.values.PaymentId === "5") {
        typePayment = "CORPORATE";
      }

      const paymentPayload = {
        type: typePayment,
        userId: userSub,
      };

      // 2. Make the POST request cleanly with Axios
      const response = await axios.post(LINKS_API, paymentPayload);

      // 3. The backend returns the final generated link inside response.data.url
      if (response.data && response.data.url) {
        window.location.href = response.data.url;
      }
    } catch (error) {
      console.log("Registration Error:", error);

      toast.error(error.message || "Something went wrong", {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  };

  // const onSubmit = async (data) => {
  //   try {
  //     console.log(props);
  //     const inputArray = data.siteDetails;
  //     console.log("key", siteAdressArray);
  //     const siteDetailsId = [];
  //     const distributionId = [];
  //     const siteDetails1 = [];
  //     const siteName = [];
  //     const unitNumber = [];
  //     const distributionBox = [];
  //     const distriLocation = [];
  //     inputArray.forEach(function (d, idx) {
  //       //  let detailedAddress = siteAdressArray[idx];
  //       //  console.log(detailedAddress);
  //       // client.graphql({
  //       //   query: mutations.createSiteDetails,
  //       //  variables: {
  //       //  input: {
  //       //  unitNumber: d.siteAddress,
  //       // siteName: d.siteName,
  //       // ------------start-----
  //       // street: detailedAddress.hasOwnProperty("street")
  //       //   ? detailedAddress.street
  //       //   : "",
  //       // suburb: detailedAddress.hasOwnProperty("suburb")
  //       //   ? detailedAddress.suburb
  //       //   : "",
  //       // state: detailedAddress.hasOwnProperty("state")
  //       //   ? detailedAddress.state
  //       //   : "",
  //       // postCode: detailedAddress.hasOwnProperty("postCode")
  //       //   ? detailedAddress.postCode
  //       //   : "",
  //       // country: detailedAddress.hasOwnProperty("country")
  //       //   ? detailedAddress.country
  //       //   : "",
  //       //   --- previous commented lines-----
  //       //  assetownerID: props.values.UserId,
  //       //  companydetailsID: props.values.CompanyId,
  //       //   status: "Active",
  //       //  },
  //       // },
  //       //  authMode: "API_KEY",
  //       // })
  //       // .then((result) => {
  //       // siteDetailsId.push(result.data.createSiteDetails.id);
  //       siteName.push(d.siteName);
  //       unitNumber.push(d.siteAddress);
  //       //  client.graphql({
  //       //  query: mutations.createDistributionBox,
  //       //  variables: {
  //       //   input: {
  //       //     distributionBoxName: d.distributionBox,
  //       //     location: d.location,
  //       //     sitedetailsID: result.data.createSiteDetails.id,
  //       //      status: "Active",
  //       //      distributionBoxNumber: "DB" + catId + maxNum,
  //       //    },
  //       //   },
  //       //   authMode: "API_KEY",
  //       // }).then((result2) => {
  //       //  console.log(result2);
  //       //  distributionId.push(result2.data.createDistributionBox.id);
  //       distributionBox.push(d.distributionBox);
  //       distriLocation.push(d.location);
  //       console.log(siteDetailsId);
  //       console.log(distributionId);
  //       console.log(distributionBox);
  //       console.log(distriLocation);
  //       console.log(siteName);
  //       console.log(unitNumber);
  //       siteDetails1.push({
  //         siteName: d.siteName,
  //         SiteAddress: d.siteAddress,
  //         DbName: d.distributionBox,
  //         location: d.location,
  //       });

  //       props.values.siteDetails = siteDetails1;
  //       // client.graphql({
  //       //   query: mutations.createLogBook,
  //       //   variables: {
  //       //     limit: 10000,
  //       //     input: {
  //       //       siteId: result.data.createSiteDetails.id,
  //       //       sitedetailsID: result.data.createSiteDetails.id,
  //       //      distributionBox: result2.data.createDistributionBox.id,
  //       //       status: "Active",
  //       //       logbookName: d.siteName + " - Default Logbook",
  //       //     },
  //       //   },
  //       //   authMode: "API_KEY",
  //       // }).then((result1) => {
  //       //   console.log(result1);
  //       //  });
  //       //  });
  //       //  client.graphql({
  //       //   query: mutations.createLinkUsersAndSite,
  //       //  variables: {
  //       //    input: {
  //       //      sitedetailsID: result.data.createSiteDetails.id,
  //       //       userdetailsID: props.values.UserId,
  //       //      status: "Active",
  //       //     },
  //       //   },
  //       //    authMode: "API_KEY",
  //       //  });
  //       //   console.log(result);
  //       //   })
  //       //  .catch((error) => {
  //       //    console.log(error);
  //       //   });
  //       // });

  //       // --------previous ---- commented  start ----
  //       // await inputArray.map(async function(d, idx){
  //       //   let detailedAddress = siteAdressArray[idx];

  //       //     const updateUser = await client.graphql({queries:mutations.updateUserDetails, { input: { id: state.userId, siteDetailsId: siteDetailsId, _version: getUserDetail[0]._version}}));
  //       //     console.log(updateUser);
  //       //     console.log(dataDetails);

  //       // });
  //       // --------previous ---- commented  last ----
  //       // client.graphql({
  //       //  query: mutations.updateUserDetails,
  //       //  variables: {
  //       ////   input: {
  //       //     id: props.values.UserId,
  //       //     siteDetailsId: siteDetailsId,
  //       //   },
  //       // },
  //       // authMode: "API_KEY",
  //       // })
  //       // .then((userUpdate) => {
  //       //   console.log(userUpdate);
  //       //   toast.success("Site Details Saved Succesfully!..", {
  //       //     position: toast.POSITION.TOP_CENTER,
  //       //   });
  //       props.values.SiteIds = siteDetailsId;
  //       props.values.siteName = siteName;
  //       props.values.UnitNumber = unitNumber;
  //       props.values.distributionBoxName = distributionBox;
  //       props.values.distributionBoxLocation = distriLocation;
  //       props.nextStep();
  //       //  })
  //       // .catch((error) => {
  //       //   console.log(error);
  //       //  toast.error("Error while Creating ", {
  //       //    position: toast.POSITION.TOP_CENTER,
  //       //  });
  //     });
  //   } catch (err) {
  //     toast.error(err.message, {
  //       position: toast.POSITION.TOP_CENTER,
  //     });
  //   }
  // };
  //------------------------------------------------------------------------------

  // const onSubmit = useCallback(async (data) => {
  //   const userDetails = await client.graphql({
  //     query: queries.listUserDetails,
  //     authMode: 'API_KEY'
  //   });
  //   const getUserDetail = userDetails.data.listUserDetails.items.filter(item => item.id === state?.userId);
  //   const companyId = getUserDetail[0]?.companyDetailsId;
  //   const inputArray=data.siteDetails;
  //   const siteDetailsId = [];
  //   await inputArray.map(async function(d, idx){
  //     const detailedAddress = siteAdressArray[idx];
  //     await client.graphql({
  //       query: mutations.createSiteDetails,
  //       variables: {input: {
  //         unitNumber:d.unitNumber,
  //         street:detailedAddress.hasOwnProperty('street') ? detailedAddress.street : '',
  //         suburb:detailedAddress.hasOwnProperty('suburb') ? detailedAddress.suburb : '',
  //         state:detailedAddress.hasOwnProperty('state') ? detailedAddress.state : '',
  //         postCode:detailedAddress.hasOwnProperty('postCode') ? detailedAddress.postCode : '',
  //         country:detailedAddress.hasOwnProperty('country') ? detailedAddress.country : '',
  //         assetownerID:state.userId,
  //         companydetailsID:companyId,
  //         status:'Active'
  //       }},
  //       authMode: 'API_KEY'
  //     }).then(result =>{
  //       console.log(result);
  //       siteDetailsId.push(result.data.createSiteDetails.id);
  //       client.graphql({
  //         query: mutations.createLinkUsersAndSite,
  //         variables:{
  //           input:{
  //             sitedetailsID: result.data.createSiteDetails.id,
  //             userdetailsID: state.userId,
  //             status:'Active'
  //           }
  //         },
  //         authMode: 'API_KEY'
  //       });
  //      }).catch(error => {
  //       console.log(error);
  //       toast.error("Error While Creating!..",{
  //         position: toast.POSITION.TOP_CENTER
  //       });
  //     });
  //   });
  //   const updateUser =  client.graphql({queries:mutations.updateUserDetails, { input: { id: state.userId, siteDetailsId: siteDetailsId, _version: getUserDetail[0]._version}})).then(result => {
  //     toast.success("Site Details Saved Succesfully!..",{
  //       position: toast.POSITION.TOP_CENTER
  //     });
  //   });
  // });

  //-------------------------------------------------------------------------------------------------

  const onLoad = (autocomplete) => {
    setsiteAdress(autocomplete);
  };

  const onPlaceChanged = (index) => {
    if (siteAdress !== null) {
      let fullAddress = siteAdress.getPlace();
      let fullAddress1 = [];
      let detailAddress = fullAddress.address_components;
      for (let i = 0; i < detailAddress.length; i++) {
        if (detailAddress[i].types.includes("postal_code")) {
          fullAddress1["postCode"] = detailAddress[i].long_name;
        }
        if (detailAddress[i].types.includes("locality")) {
          fullAddress1["suburb"] = detailAddress[i].long_name;
        }
        if (detailAddress[i].types.includes("administrative_area_level_1")) {
          fullAddress1["state"] = detailAddress[i].long_name;
        }
        if (detailAddress[i].types.includes("administrative_area_level_2")) {
          fullAddress1["street"] = detailAddress[i].long_name;
        }
        if (detailAddress[i].types.includes("country")) {
          fullAddress1["country"] = detailAddress[i].long_name;
        }
      }
      setsiteAdressArray((siteAdressArray) => ({
        ...siteAdressArray,
        [index]: fullAddress1,
      }));
    } else {
      console.log("Autocomplete is not loaded yet!");
    }
  };
  return (
    <Fragment>
      <div
        className="d-flex justify-content-center"
        style={{
          background: "#f8fafc",
          minHeight: "100vh",
        }}
      >
        <div
          className="card border-0 shadow-sm"
          style={{
            width: "100%",
            maxWidth: "700px",
            borderRadius: "24px",
            background: "#ffffff",
          }}
        >
          <div className="p-5">
            {/* HEADER */}
            <div className="mb-4 text-center">
              <H2
                style={{
                  fontWeight: "700",
                  color: "#0f172a",
                  marginBottom: "10px",
                }}
              >
                Add Your First Site
              </H2>

              <P
                style={{
                  color: "#64748b",
                  fontSize: "15px",
                }}
              >
                You can add more sites later from your dashboard.
              </P>
            </div>

            <Form
              className="needs-validation"
              noValidate
              onSubmit={handleSubmit(onSubmit)}
            >
              {fields.map((item, index) => {
                return (
                  <div
                    key={`${item.fieldId}-${index}`}
                    className="mb-4"
                    style={{
                      border: fields.length > 1 ? "1px solid #e2e8f0" : "none",
                      borderRadius: "16px",
                      padding: fields.length > 1 ? "20px" : "0px",
                      position: "relative",
                    }}
                  >
                    {/* REMOVE BUTTON */}
                    {fields.length > 1 && (
                      <button
                        type="button"
                        onClick={() => remove(index)}
                        style={{
                          position: "absolute",
                          top: "12px",
                          right: "12px",
                        }}
                      >
                        ×
                      </button>
                    )}

                    {/* SITE NAME */}
                    <Row>
                      <Col md="12" className="mb-4">
                        <Label
                          className="fw-semibold mb-2"
                          style={{
                            color: "#0f172a",
                          }}
                        >
                          Site Name
                        </Label>

                        <input
                          className="form-control form-control-lg"
                          placeholder="Site Name"
                          {...register(`siteDetails.${index}.siteName`, {
                            required: true,
                          })}
                          style={{
                            borderRadius: "14px",
                            height: "56px",
                            border: "1px solid #dbe4f0",
                            fontSize: "15px",
                          }}
                        />

                        <span className="text-danger small">
                          {errors.siteDetails?.[index]?.siteName &&
                            "Site Name is required"}
                        </span>
                      </Col>
                    </Row>

                    {/* SITE ADDRESS */}
                    <Row>
                      <Col md="12" className="mb-3">
                        <Label
                          className="fw-semibold mb-2"
                          style={{
                            color: "#0f172a",
                          }}
                        >
                          Site Address
                        </Label>

                        {isLoaded ? (
                          <Autocomplete
                            onLoad={onLoad}
                            onPlaceChanged={() => onPlaceChanged(index)}
                            options={{
                              types: ["address"],
                              componentRestrictions: { country: "AU" },
                            }}
                          >
                            <input
                              type="text"
                              className="form-control form-control-lg"
                              {...register(`siteDetails.${index}.siteAddress`, {
                                required: true,
                              })}
                            />
                          </Autocomplete>
                        ) : (
                          <input
                            type="text"
                            placeholder="Loading Google Maps..."
                            className="form-control form-control-lg"
                            disabled
                            style={{
                              borderRadius: "14px",
                              height: "56px",
                            }}
                          />
                        )}

                        <span className="text-danger small">
                          {errors.siteDetails?.[index]?.siteAddress &&
                            "Site Address is required"}
                        </span>
                      </Col>
                    </Row>
                  </div>
                );
              })}

              {/* ADD SITE */}
              <div className="mb-4">
                <button
                  type="button"
                  onClick={() =>
                    append({
                      siteName: "",
                      siteAddress: "",
                      distributionBox: "",
                      location: "",
                    })
                  }
                  style={{
                    width: "100%",
                    height: "52px",
                    borderRadius: "14px",
                    border: "1.5px dashed #c7d2fe",
                    background: "#f8fafc",
                    color: "#2563eb",
                    fontWeight: "600",
                    fontSize: "15px",
                    cursor: "pointer",
                    transition: "all 0.25s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.background = "#eef2ff";
                    e.target.style.borderColor = "#6366f1";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.background = "#f8fafc";
                    e.target.style.borderColor = "#c7d2fe";
                  }}
                >
                  + Add Another Site
                </button>
              </div>

              {/* ILLUSTRATION */}
              <div className="text-center mb-4">
                <img src={siteDetailsImg} alt="site" />
              </div>

              {/* BUTTON */}
              <button
                type="submit"
                style={{
                  width: "100%",
                  height: "56px",
                  borderRadius: "14px",
                  border: "none",
                  background: "#16a34a",
                  color: "#fff",
                  fontWeight: "600",
                  fontSize: "17px",
                  transition: "0.3s",
                }}
              >
                Go to Dashboard
              </button>
            </Form>
          </div>
        </div>
      </div>
    </Fragment>
  );
};
export default SiteDetails;
